

function Footer() {
    return (
        <footer className="p-3 text-white">
        Copyright &#169; 2021 Liz Townsend
    
      </footer>
    
    )
};

export default Footer;